import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import NavLinks from '../NavLinks';

import useTeamData from '../../../state/team/UseTeamData';
import useTeamFacilityLinksData from '../../../state/teamFacilityLinks/UseTeamsFacilityLinksData';

import useSearchFacility from '@usas/ui-web/components/searches/searchFacility/UseSearchFacility';

import useFacilityData from '@usas/ui-web/state/facility/UseFacilityData';

import Constants from '@usas/ui-web/utils/Constants';

const useTeamFacilitySearch = () => {
  const navigate = useNavigate();
  const { searchFacilityState, setSearchFacilityState, getFacility } = useSearchFacility();
  const { facilityState } = useFacilityData();
  const { teamState } = useTeamData();
  const { teamFacilityLinksState, postTeamFacilityLinks, getTeamFacilityLinks, clearTeamFacilityLinksArrayData } = useTeamFacilityLinksData();
  const [modalState, setModalState] = useState(getInitialModalState);
  const [state, setState] = useState({ facilityId: Constants.DEFAULT_ID });
  
  function createObjectForPost(facilityObjData) {
    return {
      orgUnitId: teamState.objData.orgUnitId,
      facilityId: facilityObjData.facilityId,
      effectiveDate: null,
      expirationDate: null,
      facility: undefined,
      clubFacilityContactName: null,
      clubFacilityContactEmailAddress: null,
      clubFacilityContactPhoneNumber: null,
      facilityContactName: facilityObjData.contactName,
      facilityContactEmailAddress: facilityObjData.contactEmailAddress,
      facilityContactPhoneNumber: facilityObjData.contactPhoneNumber
    };
  }

  const onLinkFacility = (e, facilityId) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    let dupFacility = null;
    for (const orgUnitFacility of teamFacilityLinksState.arrayData) {
      if (orgUnitFacility.facilityId === facilityId) {
        dupFacility = orgUnitFacility.facility;
        break;
      }
    }

    if (dupFacility === null) {
      setState({ ...state, facilityId: facilityId });
      getFacility(facilityId);
      setModalState(getInitialModalState);
    }
    else {
      setModalState({
        ...modalState,
        displayModal: true,
        facilityName: dupFacility.facilityName || ''
      });
    }
  };

  const onCancelClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    navigate(NavLinks.TEAM_FACILITY);
  };

  const onModalCancel = () => {
    setModalState(getInitialModalState);
  };

  const onAddANewFacility = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    navigate(NavLinks.TEAM_FACILITY_ADD);
  };

  useEffect(() => {
    clearTeamFacilityLinksArrayData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (facilityState.isObjLoaded === true && state.facilityId === facilityState.objData.facilityId) {
      postTeamFacilityLinks(teamState.objData.orgUnitId, createObjectForPost(facilityState.objData));
      setSearchFacilityState({ ...searchFacilityState, tryRedirect: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityState]);

  useEffect(() => {
    //Wait for add to complete before getting updated club & redirecting
    if (teamFacilityLinksState.isSaving === false && searchFacilityState.tryRedirect === true && state.facilityId > 0) {
      getTeamFacilityLinks(teamState.objData.orgUnitId);
      setSearchFacilityState({ ...searchFacilityState, tryRedirect: false });
      navigate(NavLinks.TEAM_FACILITY_DETAIL, { state: { facilityId: state.facilityId } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamFacilityLinksState, searchFacilityState, state]);

  function getInitialModalState() {
    return {
      displayModal: false,
      facilityName: '',
    };
  }

  return {
    facilityState,
    teamState,
    modalState,
    onLinkFacility,
    onCancelClicked,
    onModalCancel,
    onAddANewFacility
  };
};

export default useTeamFacilitySearch;